<template>
  <div class="c-order-and-name">
    <tooltip :label="data.trackNumber" placement="left">
      <p class="order">{{ formatTrackNumber }}</p>
    </tooltip>

    <router-link class="cover" :class="[`cover--size--${size}`]"
      :to="{ path: `/explore/albums-info/${data.track?.album?.albumUid || data.albumUid}` }">
      <img class="cover__img" :src="imageSource(
          data.cover ||
          data.track?.artworkInfo ||
          data.album?.artworkInfo ||
          data.artworkInfo,
        )
        " />
    </router-link>

    <p class="text">
      <tooltip :label="title" cusPlacementType="order-name">
        <span class="text__name">{{ title }}</span>
      </tooltip>
    </p>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import Tooltip from '@/components/Global/Tooltip.vue';
import imageSource from '@/utils/imageSource';
import { handleComplexTrackNumber } from '@/utils/helper';

export default defineComponent({
  name: 'OrderCoverName',
  components: {
    Tooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    idx: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const title = computed(() => props.data?.track?.trackTitleDisplay || props.data?.trackTitleDisplay || '');

    const formatTrackNumber = computed(() => {
      const { trackNumber } = props.data;
      const tempStr = handleComplexTrackNumber(trackNumber);

      return tempStr;
    });

    return {
      title,
      imageSource,
      formatTrackNumber,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-order-and-name {
  @include flex(flex-start, flex-start);
  @include padding(0 20px 0 0);
  max-width: 500px;

}

.order {
  flex: none;
  @include font-style($c-assist3, 14, bold, 0.8px, 26px);
  /* margin-right: 16px; */
  width: 35px;
  // opacity: 0;
}

.cover {
  flex: none;
  width: 36px;
  height: 36px;
  margin-right: 10px;

  &--size--small {
    width: 26px;
    height: 26px;
  }

  &__img {
    width: 100%;
    cursor: pointer;
  }
}

.text {
  // width: 100%;
  @include padding(0px 20px 0px 0);

  max-width: 500px;

  &__name {
    margin-left: 5px;
    @include font-style($c-black, 14, bold, 0.8px, 26px);
    @include word-ellipsis(2);
  }
}
</style>
